import { render, staticRenderFns } from "./DiagnosisCode.vue?vue&type=template&id=8a9e651c&"
import script from "./DiagnosisCode.vue?vue&type=script&lang=js&"
export * from "./DiagnosisCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports